import React from "react";
import Caption from "../Caption";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { ZoomInHoc, ZoomOutHoc, ZoomRestoreHoc } from "../../../../assets/images";
// import imageUrl from "../../../../assets/mock/download.jpeg"
const Image = (props = {}) => {
  const { media: { fileDetails:{imageUrl=""} ={} } } = props
  /**
  // const [getImage, setImage] = ({
  //   imgSrc: URL.createObjectURL(props.media)
  // });
  // const { imgSrc } = getImage;

  // React.useEffect(() => {
  //   props.updateMedia(props.media, {
  //     imageUrl: imgSrc,
  //     msgType: "image"
  //   });
  // }, []);
  */

  return (
    <div className="type-image" id="preview">
      <div className={`imageZoomWrapper`}>
        <TransformWrapper>
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <>
              <div className="tools zoomTools">
                <button onClick={zoomIn}>
                  <ZoomInHoc />
                </button>
                <button onClick={zoomOut}>
                  <ZoomOutHoc />
                </button>
                <button onClick={resetTransform}>
                  <ZoomRestoreHoc />
                </button>
              </div>
              <TransformComponent>
                <img src={imageUrl} alt="" />
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </div>
      <Caption
        onChangeCaption={props.onChangeCaption}
        media={props.media}
        onClickSend={props.onClickSend}
      />
    </div>
  );
};
export default Image;
